import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { CommodityType } from "../models/CommodityType";

export const getCommodityTypes = async (
  OnlyActive?: boolean | null,
  signal?: AbortSignal,
) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "OnlyActive", value: OnlyActive ?? true },
  ];
  return await apiService.callV2(
    "[SCRAP].[GetCommodityTypes]",
    parameters,
    signal,
  );
};

export const upsertCommodityType = async (commodityType: CommodityType) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "CommodityTypeId", value: commodityType.CommodityTypeId },
    { name: "CommodityTypeName", value: commodityType.CommodityTypeName },
    { name: "IsActive", value: commodityType.IsActive },
  ];
  return await apiService.callV2("[SCRAP].[UpsertCommodityType]", parameters);
};

export const deleteCommodityType = async (CommodityTypeId: number | null) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "CommodityTypeId", value: CommodityTypeId },
  ];
  return await apiService.callV2("[SCRAP].[DeleteCommodityType]", parameters);
};
